/*
 *
 * Request constants
 *
 */

export const RESERVATION = '3849644579000';
